import { DateTime, DateTimeOptions } from 'luxon';

/**
 * Parses a string into a DateTime object using the provided format.
 *
 * Wrapper for DateTime.fromFormat that tries to parse the input with the Arabic numbering system if the default fails.
 */
export const dateTimeFromFormat = (input: string, format: string, options?: DateTimeOptions): DateTime => {
    const firstAttempt = DateTime.fromFormat(input, format, options);
    if (firstAttempt.isValid) {
        return firstAttempt;
    }
    return DateTime.fromFormat(input, format, { ...options, numberingSystem: 'arab' });
};
